import { IotaProvider } from './IotaProvider';

export async function getIotaProvider(walletId: string): Promise<IotaProvider> {
  const provider = IotaProvider.getInstance();

  if (!provider.isConnected) {
    await provider.connect(walletId);
  }

  return provider;
}
